import { replaceNewLinesWithBr } from '@lib/core';
import { AbstractViewModel } from '../../abstract.view.model';
import { GadgetApiModel } from '../../api-model/gadget/gadget.api.model';
import { TagGroupViewModel } from '../tag-group.view.model';

export class GadgetViewModel extends AbstractViewModel<GadgetApiModel> {
  itemId: string;
  name: string;
  description: string;

  price: number;
  taxRate?: number;

  customText1?: string;
  customText2?: string;
  customText3?: string;

  pictures?: string[];
  tagGroups?: TagGroupViewModel[];

  quantity: number = 0;

  constructor(protected apiModel: GadgetApiModel = new GadgetApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.itemId = this.apiModel.itemId;
    this.name = this.apiModel.name;
    this.description = this.apiModel.description;
    this.price = this.apiModel.price;
    this.taxRate = this.apiModel.taxRate;
    this.customText1 = replaceNewLinesWithBr(this.apiModel.customText1);
    this.customText2 = replaceNewLinesWithBr(this.apiModel.customText2);
    this.customText3 = replaceNewLinesWithBr(this.apiModel.customText3);
    this.pictures = this.apiModel.pictures;
    this.tagGroups = this.apiModel.tagGroups.map((tagGroup) => new TagGroupViewModel(tagGroup));
  }

  toApiModel(): GadgetApiModel {
    return undefined;
  }
}
